<template>
  <!-- .company-info-basic .cib -->
  <div> 
    <div class="cib" v-if="openBool" style="position:relative;">
      <Button @click="$emit('finish')" style="position:absolute;top:30px;right:30px;">返回</Button>
      <Row style="margin-right:60px;">
        <Col span="12">
          <div class="cib-l">
            <div class="cib-form">
              <Form
                ref="formInline2"
                :model="formInline2"
                :rules="ruleInline2"
                label-position="right"
                :label-width="150"
                @submit.native.prevent
              >
                <FormItem label="公司名称：" prop="name">
                  <Input type="text" v-model="formInline2.name" disabled placeholder="请输入公司全称" />
                    <br />
                    <span style="font-size:12px; color:#a7a7a7;">(公司名称必须和营业执照一致)</span>
                  </FormItem>
                </FormItem>
                <FormItem label="公司简称：" prop="shortName">
                  <Input type="text" v-model="formInline2.shortName" placeholder="请输入公司简称" />
                </FormItem>
                <FormItem label="公司英文名：">
                  <Input type="text" v-model="formInline2.nameEn" placeholder="请输入公司英文名" />
                </FormItem>
                <FormItem label="公司英文简称：">
                  <Input type="text" v-model="formInline2.ShortNameEn" placeholder="请输入公司英文简称" />
                </FormItem>
                <!-- 企业类型 -->
                <!-- <FormItem label="企业类型：" prop="type">
                  <Select
                    v-model="formInline2.type"
                    placeholder="请选择企业类型"
                  >
                    <Option
                      v-for="(item, index) in exTypeList"
                      :key="item.name"
                      :value="item.name"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem> -->
                <FormItem label="人员规模：" prop="staff">
                  <Select
                    v-model="formInline2.staff"
                    placeholder="请选择人员规模"
                  >
                    <Option
                      v-for="(item, index) in staffArr"
                      :key="item.value"
                      :value="item.value"
                    >{{ item.value }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="年销售额：" prop="sales">
                  <Input
                    type="text"
                    v-model="formInline2.sales"
                    placeholder="请输入年销售额"
                  />
                </FormItem>
                <FormItem label="公司网址：" prop="Website">
                  <Input type="text" v-model="formInline2.Website" placeholder="请输入公司网址" />
                </FormItem>

                <FormItem label="国家/地区：" prop="country">  
                  <Select 
                    v-model="formInline2.country"
                    placeholder="请选择国家/地区" 
                    filterable
                  >
                    <Option
                      v-for="(item, index) in countryList"
                      :key="item.name"
                      :value="item.name" 
                    >{{ item.name }}</Option>
                  </Select>  
                </FormItem>
                <FormItem label="所在省市：" style="margin-bottom: 0;" :required="true" v-if="formInline2.country === '中国'">
                  <Row type="flex" justify="space-between">
                    <Col span="11">
                      <FormItem prop="province">
                        <Select
                          v-model="formInline2.province"
                          placeholder="请选择省份"
                          @on-change="changeProvince"
                        >
                          <Option
                            v-for="(item, index) in provinceArr"
                            :key="index"
                            :value="item.shortname?item.shortname:item.name"
                            @click.native="changeProvinceValue(item)"
                          >{{ item.shortname || item.name }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="11" v-if="citiesArr && citiesArr.length">
                      <FormItem prop="city">
                        <Select v-model="formInline2.city" placeholder="请选择城市" @on-change="changeCity">
                          <Option
                            v-for="(item, index) in citiesArr"
                            :key="index"
                            :value="item.shortname?item.shortname:item.name"
                          >{{ item.shortname || item.name }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>


                <FormItem label="地址：" prop="address">
                  <Input type="text" v-model="formInline2.address" placeholder="请输入详细地址" />
                </FormItem>
                <FormItem label="统一社会信用代码：" prop="CreditCode">
                  <Input type="text" v-model="formInline2.CreditCode" placeholder="请输入统一社会信用代码" />
                </FormItem>

                <FormItem label="企业资产类型：" prop="BusinessType">
                  <Select v-model="formInline2.BusinessType" style="width:100%">
                    <Option
                      v-for="item in BusinessList"
                      :value="item.name"
                      :key="item.name"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>

                <FormItem label="企业经营类型：" prop="Nature">
                  <Select v-model="formInline2.Nature" style="width:100%">
                    <Option
                      v-for="item in NatureList"
                      :value="item.name"
                      :key="item.name"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="公司详情：">
                  <div class="no-padding">
                    <customComponentCommon
                      v-model="Introduction"
                      :type="commonType"
                      @change="changModal"
                    ></customComponentCommon>
                  </div>
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    @click="handleSubmit('formInline2')"
                    style="width: 154px;"
                  >保存</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </Col>
        <Col span="12">
          <div class="cib-r" style="padding-top: 57px;">
            <Form label-position="right" :label-width="120" @submit.native.prevent> 
              <FormItem label="Logo：" prop="name">
                <div class="logo-example">
                  <template v-if="uploadList && uploadList.length">
                    <div
                      class="my-upload-list"
                      v-for="(item, index) in uploadList"
                      :key="'upload' + index"
                      style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;"
                    >
                      <template v-if="item.status === 'finished'">
                        <img :src="item.url" style="width: 150px;height: 150px;" v-if="item.url" />
                        <img :src="Logo" style="width: 150px;height: 150px;" v-else />
                        <div class="my-upload-list-cover">
                          <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                          <!-- <Icon
                        type="ios-trash-outline"
                        @click.native.stop.prevent="handleRemoveByArr(item)"
                          ></Icon>-->
                        </div>
                      </template>
                      <template v-else>
                        <Spin v-if="item.showProgress" style="width: 150px;height: 150px;">
                          <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                        </Spin>
                      </template>
                    </div>
                  </template>

                  <div
                    class="my-upload-list"
                    style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;"
                    v-else
                  >
                    <img :src="Logo" style="width: 150px;height: 150px;" />
                  </div>
                  <div class="logo-example-box">
                    <div class="logo-example-item z-large-s">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>图片尺寸：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-m">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>图片尺寸：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-l">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>图片尺寸：200*200px</p>
                    </div>
                  </div>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :action="uploadUrl"
                  style="display: inline-block;position: relative;"
                >
                  <Button icon="ios-cloud-upload-outline">更改Logo</Button>
                  <!-- <div style="width: 80px;height:80px;padding-top: 7px;">
                    <div>
                      +
                      <p>上传图片</p>
                    </div>
                  </div>-->
                  <!-- 蒙版 -->
                  <div
                    style="position:absolute;opacity:0;width:115px;height:34px;left:0;top:0;cursor:pointer;"
                    @click.stop="selectType"
                  ></div>
                </Upload>
                <p class="upload-p">(图片要求：2M以下的jpg或png，建议尺寸120*120px)</p>
              </FormItem>

              <FormItem label="营业执照：" :required="true">
                <div class="my-upload">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList2"
                    :key="'upload2-' + index"
                    style="width: 150px;height:100px;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width: 150px;height:100px;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 150px;height: 100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload2"
                    :show-upload-list="false"
                    :default-file-list="defaultList2"
                    :on-success="handleSuccess2"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize2"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    :before-upload="handleBeforeUpload2"
                    style="display: inline-block;width: 150px;"
                    v-show="uploadList2 && uploadList2.length <1"
                  >
                    <div style="width: 150px;height:100px;padding-top: 17px;">
                      <div style="font-size:20px">
                        +
                        <p style="font-size:14px">上传</p>
                      </div>
                    </div>
                    <!-- 蒙版 -->
                    <div
                      style="position:absolute;opacity:0;width:150px;height:100px;left:0;top:0;"
                      @click.stop="selectType2"
                    ></div>
                  </Upload>
                </div>
                <div class="my-upload-tip">（图片要求：4M以下的jpg或png）</div>
              </FormItem>
            </Form>
          </div>
        </Col>
      </Row>

      <!-- 选择文件上传方式 -->
      <imgUpload
        @upload:local="uploadLocal"
        @upload:material="uploadMaterial"
        :maxCount="1"
        v-model="uploadChooseShowed"
      />
      <!-- 选择文件上传方式 -->
      <imgUpload
        @upload:local="uploadLocal2"
        @upload:material="uploadMaterial2"
        :maxCount="1"
        v-model="uploadChooseShowed2"
      />
      <!-- 图片查看 -->
      <iModal title="图片查看" cancel-text v-model="visible">
        <div style="text-align: center;">
          <img :src="imgName" v-if="visible" style="max-width: 100%" />
        </div>
      </iModal>
    </div>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { provinces } from "@/other/provinces";
import { mapGetters, mapActions } from "vuex";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import defaultLogo from "@assets/img/empty.png";

export default {
  name: "company-info-basic",
  data() {
    const that = this;
    const cityValid = (rule, value, callback) => {
      if (that.formInline2.country === '中国') { 
        if(value) {
          callback();
        } else {
          callback(new Error("此选项为必填项"));
        }
      } else {
        callback();
      }
    };

    return {
      openBool: true,
      commonType: 2,
      Introduction: [],
      provinceArr: [],
      citiesArr: [],

      countryList: [],
      // countryList: [
      //   {
      //     value: "中国",
      //     label: "中国"
      //   }
      // ],
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      uploadChooseShowed2: false, // 控制文件上传方式的显示和隐藏
      formInline2: {
        // form双向绑定
        name: "",
        shortName: "",
        ShortNameEn: "",
        address: "",
        nameEn: "",
        introduction: "",
        country: "中国",
        province: "",
        city: "",
        Website: "",
        CreditCode: "",
        BusinessType: "",
        Nature: "",
        type: "", // 企业类型
        staff: "", // 人员规模
        sales: "", // 年销售额
      },
      ruleInline2: {
        // 效验规则
        name: [
          { required: true, message: "公司全称不能为空", trigger: "blur" },
          {
            type: "string",
            min: 3,
            message: "公司全称不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "公司全称不能大于50位",
            trigger: "blur"
          }
        ],
        shortName: [
          { required: true, message: "公司简称不能为空", trigger: "blur" },
          {
            type: "string",
            min: 2,
            message: "公司简称不能小于2位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 6,
            message: "公司简称不能大于6位",
            trigger: "blur"
          }
        ],
        introduction: [
          { required: true, message: "公司简介不能为空", trigger: "blur" },
          {
            type: "string",
            max: 2000,
            message: "公司简介不能超过2000字",
            trigger: "blur"
          }
        ],
        address: [
          { required: true, message: "公司地址不能为空", trigger: "blur" }
        ],
        country: [
          { required: true, message: "国家/地区不能为空", trigger: "blur" }
        ], 
        // province: [
        //   {
        //     required: true,
        //     message: "请选择所在的省份",
        //     trigger: "change"
        //   }
        // ],
        // city: [
        //   { required: true, message: "请选择所在的城市", trigger: "change" }
        // ], 
        province: [
          {
            required: true,
            validator: cityValid,
            trigger: "change"
          }
        ],
        city: [
          { required: true, validator: cityValid, trigger: "change" }
        ],

        Nature: [
          { required: true, message: "企业经营类型不能为空", trigger: "change" }
        ],
        BusinessType: [
          { required: true, message: "企业资产类型不能为空", trigger: "change" }
        ],

        // Website: [
        //   { required: true, message: "公司网址不能为空", trigger: "blur" },
        //   ...validator.Website
        // ],
        CreditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "blur"
          },
          ...validator.CreditCode
        ],
        // type: [
        //   { required: true, message: "请选择企业类型", trigger: "change" }
        // ],
        staff: [{ required: true, message: "请输入人员规模", trigger: "blur" }],
        sales: [{ required: true, message: "请输入年销售额", trigger: "blur" }],
      },
      visible: false,
      defaultList: [],

      uploadList: [],

      coverImg: "",
      uploadVideoFlag: false,

      defaultList2: [],
      uploadList2: [],
      limitNum1: 1, // 图文显示的限制图片个数
      BusinessList: [], // 企业性质
      NatureList: [], // 企业经营类别

      commitInfo: null, // 公司信息提交记录
      exTypeList: [],
      staffArr: [
        {
          value: "10人以下",
          label: "10人以下"
        },
        {
          value: "10~50人",
          label: "10~50人"
        },
        {
          value: "50~100人",
          label: "50~100人"
        },
        {
          value: "100~500人",
          label: "100~500人"
        },
        {
          value: "500~1000人",
          label: "500~1000人"
        },
        {
          value: "1000~5000人",
          label: "1000~5000人"
        },
        {
          value: "5000人以上",
          label: "5000人以上"
        }
      ],
    };
  },
  components: {
    imgUpload,
    customComponentCommon,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
    }),
    Logo() {
      let logo = defaultLogo;
      if (this.commitInfo && this.commitInfo.logo) {
        logo = this.commitInfo.logo;
      }
      return logo;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getCountryList: "exhibitionModule/getCountryList",
      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData",
      editCompanyDownEdit: "companyModule/editCompanyDownEdit",
      getCompanyDownList: "companyModule/getCompanyDownList",

      getNature: "companyInfoModule/getNature", // 获取企业性质
      getBusinessType: "companyInfoModule/getBusinessType", // 获取企业经营类别
      getCatalogueType: "exhibitionModule/getCatalogueType",
      getCityByParentId: "exhibitionModule/getCityByParentId",
    }),
    async init() {
      this.formInline2.name = this.company.name;
      this.commitInfo = await this.getCompanyDownList(this.joinInfo.joinId);
      if (this.commitInfo) {
        this.formInline2.shortName = this.commitInfo.shortName;
        this.formInline2.ShortNameEn = this.commitInfo.shortNameEn;
        this.formInline2.nameEn = this.commitInfo.nameEn;
        this.formInline2.address = this.commitInfo.address;
        this.formInline2.introduction = this.commitInfo.introduction;
        this.formInline2.Website = this.commitInfo.website; 
        this.formInline2.CreditCode = this.commitInfo.creditCode;
        this.formInline2.Nature = this.commitInfo.nature;
        this.formInline2.BusinessType = this.commitInfo.businessType; 
        this.defaultList = [
          {
            name: this.commitInfo.name,
            url: this.Logo,
            status: "finished",
            percentage: 100
          }
        ];
        if (this.commitInfo.businessLicenses) {
          this.defaultList2 = [
            {
              name: this.commitInfo.name,
              url: this.commitInfo.businessLicenses,
              status: "finished",
              percentage: 100
            }
          ];
        }
        if (this.commitInfo.country) {
          this.formInline2.country = this.commitInfo.country || "中国";
        }
        if (this.commitInfo.province) {
          this.changeProvince(this.commitInfo.province);
          this.formInline2.province = this.commitInfo.province || "";
        }
        if (this.commitInfo.city) {
          // this.changeCity(this.commitInfo.city);
          this.formInline2.city = this.commitInfo.city || "";
        }
        this.uploadList = this.defaultList;
        this.uploadList2 = this.defaultList2;
        if (
          this.commitInfo.introduction &&
          this.commitInfo.introduction.indexOf("[") !== -1
        ) {
          this.Introduction = await this.transformCustomData(
            JSON.parse(this.commitInfo.introduction)
          );
        }
        if (this.commitInfo.industry) {
          this.formInline2.type = this.commitInfo.industry;
        }
        this.formInline2.staff = this.commitInfo.scale;
        this.formInline2.sales = this.commitInfo.annualSales;

        this.BusinessList = await this.getNature();
        this.NatureList = await this.getBusinessType(); 
        let countryList = await this.getCountryList();
        if (countryList && countryList.length > 0) {
          this.countryList = countryList;
        }

        let provinceList = await this.getCityByParentId("2710E818-5B91-4AA2-BCAD-0EF42A3DD6FD");
        if (provinceList && provinceList.length > 0) {
          this.provinceArr = provinceList;
          let provinceId = "";
          this.provinceArr.map(c => {
            if (c.shortname === this.formInline2.province) {
              provinceId = c.id;
            }
          })
          if (provinceId) {
            let cityList = await this.getCityByParentId(provinceId);
            if (cityList && cityList.length > 0) {
              this.citiesArr = cityList;
            }
          }
        }
        let res = await this.getCatalogueType();
        if (res) {
          this.exTypeList = res;
        }
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      // const fileList = this.$refs.upload2.fileList;
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
      // this.$refs.upload2.fileList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片"
      });
    },
    handleMaxSize2(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于4M的图片"
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`
        });
      }
      return check;
    },
    handleBeforeUpload2() {
      const limitNum = 1;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`
        });
      }
      return check;
    },
    // 选择图片上传方式
    selectType() {
      this.uploadList = [];
      this.defaultList = [];
      this.$refs.upload.fileList = [];
      this.uploadChooseShowed = true;
    },
    selectType2() {
      this.uploadList2 = [];
      this.defaultList2 = [];
      this.$refs.upload2.fileList = [];
      this.uploadChooseShowed2 = true;
      this.$refs.upload2.fileList = [];
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    uploadLocal2() {
      this.$refs.upload2.handleClick();
    },
    uploadCancel() {
      this.defaultList = [
        {
          name: this.commitInfo.name,
          url: this.commitInfo.logo,
          status: "finished",
          percentage: 100
        }
      ];
      this.uploadList = this.defaultList;
    },
    uploadCancel2() {
      if (this.commitInfo.businessLicenses) {
        this.defaultList2 = [
          {
            name: this.commitInfo.name,
            url: this.commitInfo.businessLicenses,
            status: "finished",
            percentage: 100
          }
        ];
      } else {
        this.defaultList2 = [];
      }
      this.uploadList2 = this.defaultList2;
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList.push({
            percentage: 100,
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    // 接收素材库上传的文件
    uploadMaterial2(e) {
      for (let item of e) {
        if (this.uploadList2.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList2.push({
            percentage: 100,
            status: "finished",
            url: item
          });
          this.uploadChooseShowed2 = false;
        }
      }
    },

    changeProvince(val) {
      // this.formInline2.city = this.commitInfo.city || "";
      // for (var i = 0; i < this.provinceArr.length; i++) {
      //   if (val == this.provinceArr[i].value) {
      //     this.citiesArr = this.provinceArr[i].children;
      //     this.countyArr = [];
      //   }
      // }
    },
    async changeProvinceValue(item) {
      let cityList = await this.getCityByParentId(item.id);
      // console.log(cityList);return
      if (cityList && cityList.length > 0) {
        this.citiesArr = cityList;
      } else {
        this.formInline2.city = "";
        this.citiesArr = [];
      }
    },
    changeCity(val) {
      // for (var i = 0; i < this.citiesArr.length; i++) {
      //   if (val == this.citiesArr[i].value) {
      //     this.countyArr = this.citiesArr[i].children;
      //   }
      // }
    },

    async handleSubmit(name) {
      let form = this.formInline2;
      let valid = await this.validForm(name);
      if (!valid) return;
      let logo = "";
      let BusinessLicenses = "";
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      }
      if (logo === "/static/img/empty.2bfdaae2.png") {
        logo = "";
      }
      if (this.uploadList2 && this.uploadList2.length) {
        BusinessLicenses = this.uploadList2[0].url;
      } else {
        this.$Message.error("请上传公司营业执照");
        return;
      }

      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error(`请完善详情信息`);
        return;
      }

      let req = {
        Id: this.commitInfo.id,
        // ExhibitonId: this.exhibition.id,
        // JoinId: this.joinInfo.joinId,
        // CommandId:"2", 
        SetValues: {
          Name: form.name,
          ShortName: form.shortName,
          ShortNameEn: form.ShortNameEn,
          Address: form.address,
          NameEn: form.nameEn,
          Logo: logo,
          Country: form.country,
          City: form.city,
          Province: form.province,
          Website: form.Website,
          CreditCode: form.CreditCode,
          BusinessType: form.BusinessType,
          BusinessLicenses: BusinessLicenses,
          Nature: form.Nature,
          Introduction: Introduction,
          Industry: form.type,
          Scale: form.staff,
          AnnualSales: form.sales,
        }
      };
      const bool = await this.editCompanyDownEdit(req);
      if (!bool) {
        this.$Message.error("提交未通过!");
        return false;
      }
      if (bool.errors && bool.errors[0]) {
        this.$Message.error(bool.errors[0].description);
        return;
      }
      this.$Message.success("提交成功!");
      this.$emit("finish");
    },

    changModal($event) {
      this.Introduction = $event; 
    },
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  }
};
</script>

<style scoped lang="scss">
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
</style>
